import React, { FC } from 'react';
import { Box } from '@mui/material';

const bar = 'rounded-md bg-surface-2 animate-pulse';
const card =
  'bg-surface border border-border-token rounded-xl px-5 py-5 sm:px-6 flex flex-col gap-3';

/** Loading skeleton in the real page geometry — also shown when switching experts. */
const ProfileSkeleton: FC = () => (
  <>
    <Box className="px-[24px]">
      <div className="h-4 w-44 rounded-md bg-surface-2 animate-pulse" />
    </Box>
    <Box className="px-[24px] grid gap-5 md:grid-cols-[308px_minmax(0,1fr)] items-start">
    <Box className="flex flex-col gap-5">
      <Box
        className="bg-surface border border-border-token rounded-xl overflow-hidden"
        style={{ boxShadow: 'var(--sh-2)' }}
      >
        <div className="h-[300px] bg-surface-2 animate-pulse" />
        <Box className="p-[18px] flex flex-col gap-3">
          <div className={`${bar} h-5 w-2/3`} />
          <div className={`${bar} h-3 w-11/12`} />
          <div className={`${bar} h-3 w-3/5`} />
          <div className={`${bar} h-11 w-full !rounded-xl mt-1`} />
        </Box>
      </Box>
    </Box>
    <Box className="grid gap-5 md:grid-cols-2 content-start min-w-0">
      <Box className={`${card} md:col-span-2`} style={{ boxShadow: 'var(--sh-2)' }}>
        <div className={`${bar} h-2.5 w-24`} />
        <div className={`${bar} h-3.5 w-full`} />
        <div className={`${bar} h-3.5 w-10/12`} />
        <div className={`${bar} h-3.5 w-7/12`} />
      </Box>
      <Box className={card} style={{ boxShadow: 'var(--sh-2)' }}>
        <div className={`${bar} h-2.5 w-20`} />
        <div className={`${bar} h-8 w-full !rounded-full`} />
      </Box>
      <Box className={card} style={{ boxShadow: 'var(--sh-2)' }}>
        <div className={`${bar} h-2.5 w-24`} />
        <div className={`${bar} h-3.5 w-full`} />
        <div className={`${bar} h-3.5 w-8/12`} />
      </Box>
      <Box className={`${card} md:col-span-2`} style={{ boxShadow: 'var(--sh-2)' }}>
        <div className={`${bar} h-2.5 w-20`} />
        <div className={`${bar} h-3.5 w-full`} />
        <div className={`${bar} h-3.5 w-full`} />
        <div className={`${bar} h-3.5 w-9/12`} />
      </Box>
    </Box>
    </Box>
  </>
);

export default ProfileSkeleton;
